module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group lp-flex-box",
    class: {
      'has-error': _vm.biz.nickname == ''
    },
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("名称")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.nickname),
      expression: "biz.nickname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nickname",
      "id": "nickname"
    },
    domProps: {
      "value": (_vm.biz.nickname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.biz, "nickname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    class: {
      'has-error': _vm.biz.username == ''
    },
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("账号")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.username),
      expression: "biz.username"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "name": "username",
      "id": "username"
    },
    domProps: {
      "value": (_vm.biz.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.biz, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    class: {
      'has-error': _vm.biz.roleId == 0
    },
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("角色")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.roleId),
      expression: "biz.roleId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "account-role"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.biz, "roleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("设置角色")]), _vm._v(" "), _vm._l((_vm.biz.roles), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.description))])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("项目权限")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('select', {
    staticClass: "form-control select2",
    attrs: {
      "id": "select2_sample_modal_2",
      "multiple": ""
    }
  }, _vm._l((_vm.biz.communities), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.description))])
  }), 0)]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    staticStyle: {
      "align": "left"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d02defe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/AccountEdit.vue
// module id = 312
// module chunks = 2 3